import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { warningAlert } from "@/utility/helpers";
import { debounce, getActiveShop } from "@/constants/utility";
import ModalFull from "@/custom_components/ModalFull";
import { withAuthentication } from "@/hoc/withAuthentication";
import VerificationForm from "./VerificationForm";

const VerifyShop = ({ user, close, httpClient }) => {
  const shop = getActiveShop(user);
  const handleSubmit = async (values) => {
    try {
      let body = {
        Repair_Shop: shop?.name,
        StoreId: shop?.shopId,
        ...values,
      };
      const requestOptions = {
        method: "POST",
        body: JSON.stringify(body),
      };
      const { Website, Facebook, Instagram, Twitter, Other_Link } = values;
      await fetch(
        "https://hooks.zapier.com/hooks/catch/8079642/b9hb4bt",
        requestOptions
      );
      let res = await httpClient.post(
        `/repairshop/requestValidation/${shop?._id}`,
        {
          website: Website,
          fb: Facebook,
          in: Instagram,
          x: Twitter,
          other: Other_Link,
        }
      );
      warningAlert({
        message: "Shop validation requested successfully!",
        status: "success",
      });
      close();
    } catch (err) {
      warningAlert({ message: err.message });
      close();
    }
  };
  const render = (
    <div className="uk-padding-small uk-margin-auto uk-margin-large-top">
      <span className="uk-text-large uk-text-bold">Verification Form</span>
      <div className="uk-margin-small-top uk-text-small uk-text-muted">
        Please fill the information below to get your account verified.
      </div>
      <div className="uk-margin">
        <VerificationForm close={close} handleSubmit={handleSubmit} />
      </div>
    </div>
  );
  return (
    <>
      <ModalFull zIndex={3} hideCloseBtn={true}>
        <div className="uk-padding-remove-horizontal">
          <header className="uk-flex uk-flex-between uk-flex-middle uk-clearfix uk-card-header uk-text-center uk-background-danger tm-text-white uk-width-1-1 uk-margin-bottom">
            <div className="uk-text-left">
              <div className="uk-flex uk-flex-between uk-flex-middle"></div>
            </div>
            <div className="uk-text-center">
              <img
                style={{height: "40px" }}
                src={`/icons/header/logo-${
                  user.isRetail ? "retail" : "repair"
                }.svg`}
              />
              {/* <img className="uk-svg" src="/icons/header/logo.svg" /> */}
            </div>
            <div className="uk-text-right"></div>
          </header>
          <div className="uk-width-1-2 uk-margin-auto">{render}</div>
        </div>
      </ModalFull>
      <style jsx>{`
        .p-5 {
          font-size: 1.7em;
        }

        .opaq {
          opacity: 0.5;
        }

        .font-large {
          font-size: 3rem;
        }
      `}</style>
    </>
  );
};

export default withAuthentication(withRouter(VerifyShop));
